document.addEventListener("DOMContentLoaded", () => {
  initMobileMenu();
  initProductGalleries();
  initProductForms();
  initProductRecommendations();
});

function initMobileMenu() {
  const button = document.querySelector("[data-menu-toggle]");
  const menu = document.querySelector("#DarkTechMobileMenu");

  if (!button || !menu) return;

  button.addEventListener("click", () => {
    const open = button.getAttribute("aria-expanded") !== "true";
    button.setAttribute("aria-expanded", String(open));
    menu.hidden = !open;
  });

  menu.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", () => {
      button.setAttribute("aria-expanded", "false");
      menu.hidden = true;
    });
  });
}

function initProductGalleries() {
  document.querySelectorAll("[data-product-root]").forEach((root) => {
    const mainImage = root.querySelector("[data-main-media] img");
    if (!mainImage) return;

    const thumbs = Array.from(
      root.querySelectorAll("[data-media-thumb]")
    );

    const jsonNode = root.querySelector("[data-product-json]");

    let galleryVariants = [];

    if (jsonNode) {
      try {
        galleryVariants = JSON.parse(jsonNode.textContent);
      } catch (error) {
        galleryVariants = [];
      }
    }

    // 产品默认主图
    const defaultMainImage = {
      src: mainImage.src,
      srcset: mainImage.getAttribute("srcset")
    };

    function normalizeImageUrl(url) {
      if (!url) return "";
      return String(url).split("?")[0];
    }

    function getVariantImageUrl(variant) {
      return normalizeImageUrl(
        variant?.featured_image?.src ||
        variant?.featured_media?.preview_image?.src ||
        ""
      );
    }

    function sameImage(urlA, urlB) {
      const a = normalizeImageUrl(urlA);
      const b = normalizeImageUrl(urlB);

      if (!a || !b) return false;

      return (
        a === b ||
        a.includes(b) ||
        b.includes(a)
      );
    }

    // 判断缩略图属于当前颜色、其他颜色，还是公共图
    function shouldShowThumb(thumb, variant) {
      const thumbUrl = normalizeImageUrl(
        thumb.dataset.imageUrl
      );

      if (!thumbUrl) return true;

      const currentVariantUrl =
        getVariantImageUrl(variant);

      // 这张图是否被任何 Variant 绑定
      const ownerVariant = galleryVariants.find((item) => {
        const itemUrl = getVariantImageUrl(item);
        return itemUrl && sameImage(thumbUrl, itemUrl);
      });

      // 没绑定给任何 Variant = 公共图
      if (!ownerVariant) {
        return true;
      }

      // 当前 Variant 自己的图片
      if (
        currentVariantUrl &&
        sameImage(thumbUrl, currentVariantUrl)
      ) {
        return true;
      }

      // 其他 Variant 的主图
      return false;
    }

    // 给 initProductForms 调用
    root._dtSetVariantImage = function (variant) {
      const variantImage = getVariantImageUrl(variant);

      // 先过滤缩略图
      thumbs.forEach((thumb) => {
        const show = shouldShowThumb(thumb, variant);
        thumb.style.display = show ? "" : "none";
      });

      // Variant 有绑定主图
      if (variantImage) {
        mainImage.src = variantImage;
        mainImage.removeAttribute("srcset");

        let matchedThumb = null;

        thumbs.forEach((thumb) => {
          const matched = sameImage(
            thumb.dataset.imageUrl,
            variantImage
          );

          thumb.classList.toggle(
            "is-active",
            matched
          );

          if (matched && !matchedThumb) {
            matchedThumb = thumb;
          }
        });

        if (matchedThumb) {
          matchedThumb.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "nearest"
          });
        }

        return;
      }

      // Variant 没绑定图片 → 默认主图
      mainImage.src = defaultMainImage.src;

      if (defaultMainImage.srcset) {
        mainImage.setAttribute(
          "srcset",
          defaultMainImage.srcset
        );
      } else {
        mainImage.removeAttribute("srcset");
      }

      thumbs.forEach((thumb, index) => {
        thumb.classList.toggle(
          "is-active",
          index === 0
        );
      });
    };

    // 手动点击缩略图仍然可以切换主图
    thumbs.forEach((button) => {
      button.addEventListener("click", () => {
        const imageUrl = button.dataset.imageUrl;

        if (imageUrl) {
          mainImage.src = imageUrl;
          mainImage.removeAttribute("srcset");
        }

        thumbs.forEach((item) => {
          item.classList.toggle(
            "is-active",
            item === button
          );
        });
      });
    });
  });
}

function initProductForms() {
  document.querySelectorAll("[data-product-root]").forEach((root) => {
    const jsonNode = root.querySelector("[data-product-json]");
    const form = root.querySelector("[data-product-form]");

    if (!jsonNode || !form) return;

    let variants = [];

    try {
      variants = JSON.parse(jsonNode.textContent);
    } catch (error) {
      console.error("Unable to parse product variants.", error);
      return;
    }

    const idInput =
      form.querySelector("[data-variant-id]") ||
      form.querySelector('input[name="id"]');

    const qtyInput =
      form.querySelector("[data-qty-input]") ||
      form.querySelector('input[name="quantity"]');

    const priceNode = root.querySelector("[data-product-price]");
    const compareNode = root.querySelector("[data-compare-price]");
    const stockNode = root.querySelector("[data-stock-message]");
    const addButton =
      root.querySelector("[data-add-button]") ||
      form.querySelector('button[type="submit"]');

    const addLabel = root.querySelector("[data-add-label]");
    const buttonPrice = root.querySelector("[data-button-price]");
    const optionGroups = Array.from(
      root.querySelectorAll("[data-option-index]")
    );

    function selectedOptions() {
      return optionGroups.map((group) => {
        const selected = group.querySelector(
          '[data-option-button][aria-pressed="true"]'
        );

        return selected ? selected.dataset.optionValue : null;
      });
    }

    function findVariant() {
      const selections = selectedOptions();

      return variants.find((variant) =>
        selections.every((value, index) => {
          return value === null || variant.options?.[index] === value;
        })
      );
    }

    function money(cents) {
      const amount = Number(cents || 0) / 100;

      try {
        return new Intl.NumberFormat(
          document.documentElement.lang || "en",
          {
            style: "currency",
            currency: window.Shopify?.currency?.active || "USD"
          }
        ).format(amount);
      } catch {
        return `$${amount.toFixed(2)}`;
      }
    }

    function updateVariant(variant) {
      if (!variant) {
        if (addButton) addButton.disabled = true;
        if (addLabel) addLabel.textContent = "Unavailable";
        if (stockNode) stockNode.textContent = "Combination unavailable";
        return;
      }

      if (idInput) idInput.value = variant.id;
      if (priceNode) priceNode.textContent = money(variant.price);
      if (buttonPrice) {
  const qty = Math.max(1, parseInt(qtyInput?.value || "1", 10));
  buttonPrice.textContent = money(variant.price * qty);
}

      if (compareNode) {
        const hasCompare =
          variant.compare_at_price &&
          variant.compare_at_price > variant.price;

        compareNode.hidden = !hasCompare;

        if (hasCompare) {
          compareNode.textContent = money(variant.compare_at_price);
        }
      }

      const available = variant.available !== false;

      if (stockNode) {
        stockNode.textContent = available
          ? "In stock · ready to add"
          : "Currently unavailable";
      }

      if (addButton) addButton.disabled = !available;

      if (addLabel) {
        addLabel.textContent = available ? "Add to cart" : "Sold out";
      }

      try {
        const url = new URL(window.location.href);
        url.searchParams.set("variant", variant.id);
        window.history.replaceState({}, "", url.toString());
      } catch {}
    }

    root.querySelectorAll("[data-option-button]").forEach((button) => {
      button.addEventListener("click", () => {
        const index = button.dataset.optionIndex;
        const group = root.querySelector(
          `[data-option-index="${index}"]`
        );

        if (!group) return;

        group.querySelectorAll("[data-option-button]").forEach((item) => {
          const selected = item === button;
          item.classList.toggle("is-selected", selected);
          item.setAttribute("aria-pressed", String(selected));
        });

        const label = group.querySelector("[data-selected-option]");
        if (label) label.textContent = button.dataset.optionValue;

        const variant = findVariant();

   if (typeof root._dtSetVariantImage === "function") {
    root._dtSetVariantImage(variant);
   }

updateVariant(variant);
      });
    });

    form.querySelector("[data-qty-minus]")?.addEventListener("click", () => {
      const current = Math.max(
        1,
        parseInt(qtyInput?.value || "1", 10)
      );

      if (qtyInput) qtyInput.value = Math.max(1, current - 1);

const variant = findVariant();
if (variant && buttonPrice) {
  const qty = Math.max(1, parseInt(qtyInput?.value || "1", 10));
  buttonPrice.textContent = money(variant.price * qty);
}
    });

    form.querySelector("[data-qty-plus]")?.addEventListener("click", () => {
      const current = Math.max(
        1,
        parseInt(qtyInput?.value || "1", 10)
      );

      if (qtyInput) qtyInput.value = current + 1;
      const variant = findVariant();
if (variant && buttonPrice) {
  const qty = Math.max(1, parseInt(qtyInput?.value || "1", 10));
  buttonPrice.textContent = money(variant.price * qty);
}
    });

    form.addEventListener("submit", async (event) => {
      event.preventDefault();

      if (!addButton || addButton.disabled) return;

      const variant = findVariant();

      if (!variant) {
        if (addLabel) addLabel.textContent = "Unavailable";
        return;
      }

      const variantId = Number(variant.id);
      const quantity = Math.max(
        1,
        parseInt(qtyInput?.value || "1", 10)
      );

      const originalLabel = addLabel?.textContent || "Add to cart";

      addButton.disabled = true;
      if (addLabel) addLabel.textContent = "Adding...";

      try {
        const response = await fetch(
          window.Shopify.routes.root + "cart/add.js",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
            },
            body: JSON.stringify({
              items: [
                {
                  id: variantId,
                  quantity
                }
              ]
            })
          }
        );

        const data = await response.json();

        if (!response.ok) {
          throw new Error(
            data.description ||
            data.message ||
            "Unable to add product to cart."
          );
        }

        if (addLabel) addLabel.textContent = "Added ✓";

        await refreshCartCount();

        setTimeout(() => {
          if (addLabel) addLabel.textContent = originalLabel;
          addButton.disabled = false;
        }, 1200);
      } catch (error) {
        console.error("Add to cart error:", error);

        if (addLabel) {
          addLabel.textContent = error.message || "Try again";
        }

        addButton.disabled = false;
      }
    });

    updateVariant(findVariant() || variants.find((v) => v.available) || variants[0]);
  });
}

async function refreshCartCount() {
  try {
    const response = await fetch(
      window.Shopify.routes.root + "cart.js",
      {
        headers: {
          Accept: "application/json"
        }
      }
    );

    if (!response.ok) return;

    const cart = await response.json();

    document.querySelectorAll(".dt-cart-count").forEach((node) => {
      node.textContent = cart.item_count;
    });

    if (
      cart.item_count > 0 &&
      !document.querySelector(".dt-cart-count")
    ) {
      const cartLink = document.querySelector('a[href*="/cart"]');

      if (cartLink) {
        const badge = document.createElement("span");
        badge.className = "dt-cart-count";
        badge.textContent = cart.item_count;
        cartLink.appendChild(badge);
      }
    }
  } catch (error) {
    console.error("Unable to update cart count.", error);
  }
}

function initProductRecommendations() {
  document
    .querySelectorAll("product-recommendations")
    .forEach((element) => {
      const url = element.dataset.url;
      if (!url) return;

      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;

          const recommendations = html.querySelector(
            "product-recommendations"
          );

          if (
            recommendations &&
            recommendations.innerHTML.trim().length
          ) {
            element.innerHTML = recommendations.innerHTML;
          }
        })
        .catch((error) => {
          console.error(
            "Unable to load product recommendations.",
            error
          );
        });
    });
}
document.querySelectorAll("[data-cart-change]").forEach((button) => {
  button.addEventListener("click", async () => {
    const key = button.dataset.lineKey;
    const change = Number(button.dataset.cartChange);

    const quantityInput = button.parentElement.querySelector(".dt-cart-qty-input");
    const currentQty = Number(quantityInput.value || 0);
    const newQty = Math.max(0, currentQty + change);

    try {
      const response = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          id: key,
          quantity: newQty
        })
      });

      if (!response.ok) {
        throw new Error("Unable to update cart");
      }

      window.location.reload();
    } catch (error) {
      console.error("Cart quantity update error:", error);
    }
  });
});